import cn from "@/utils/cn"
import { prettyColor, textColorFor, toCSS } from "@/utils/color-utils"
import { ComponentPropsWithoutRef } from "react"

type OrganizationCapsuleProps = {
  index: number
  title: string
  tooltip?: string
} & Omit<ComponentPropsWithoutRef<"span">, "children">

const OrganizationCapsule = ({
  title,
  tooltip,
  index,
  className,
  ...otherProps
}: OrganizationCapsuleProps) => {
  const hoverText = tooltip ?? title
  return (
    <span
      title={hoverText}
      className={cn("flex items-center rounded-full px-3 py-1", className)}
      style={{
        backgroundColor: toCSS(prettyColor(index)),
        color: toCSS(textColorFor(prettyColor(index))),
      }}
      {...otherProps}
    >
      <span
        className="w-full truncate text-center text-[14px]"
        title={hoverText}
      >
        {title}
      </span>
    </span>
  )
}

export default OrganizationCapsule
